import { Path } from "../types/path.type";
import { pipe, map, Observable, MonoTypeOperatorFunction, switchMap, filter, take } from "rxjs";

function getNestedProperty<T, P extends Path<T>>(obj: T, path: P): any {
    return (path as string).split('.').reduce((acc, key) => acc && acc[key], obj);
}


function selectProperty<T, P extends Path<T>>(path: P) {
    return pipe(
        map((obj: T) => getNestedProperty(obj, path))
    );
}

export function waitUntilPropertyIsInitialized<T, K extends Path<T>>(value$: Observable<T>, properties: K): MonoTypeOperatorFunction<T> {
    return pipe(
        switchMap(() => value$.pipe(
            selectProperty(properties),
            filter(value => Boolean(value)),
            take(1)
        ))
    );
}